import { ERROR_PROPS, ErrorVariant } from './constants'
import { ErrorView, ErrorViewProps } from './ErrorView'
import { Icon } from '@/Atomic/Atoms/Icon'

interface ErrorProps extends ErrorViewProps {
  variant?: ErrorVariant
}
export const ErrorPage: React.FC<ErrorProps> = ({
  variant = ErrorVariant.UnknownError,
  ...props
}) => {
  const variantProps = ERROR_PROPS[variant]
  const errorProps = { ...variantProps, ...props }
  return <ErrorView {...errorProps} />
}

export const ErrorTimelineCard: React.FC<ErrorProps> = ({
  variant = ErrorVariant.UnknownError,
  ...props
}) => {
  const variantProps = ERROR_PROPS[variant]
  const errorProps = { ...variantProps, ...props }
  return (
    <li>
      <Icon color="danger" icon="alert-circle" className="mb-auto" />
      <div className="arrow-box">
        <ErrorView {...errorProps} />
      </div>
    </li>
  )
}

export const ErrorCard: React.FC<ErrorProps> = ({
  variant = ErrorVariant.UnknownError,
  ...props
}) => {
  const variantProps = ERROR_PROPS[variant]
  const errorProps = { ...variantProps, ...props }
  return (
    <li>
      <div className="card w-100">
        <ErrorView {...errorProps} />
      </div>
    </li>
  )
}
